import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BusinessUser } from '@models/businesses';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SnackbarService } from '@services/ui/snackbar.service';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { GoogleEncryptionService } from 'src/app/shared/api-repos/google-encryption/google-encryption.api.service';

@UntilDestroy()
@Component({
	selector: 'app-required-pin-modal',
	templateUrl: './required-pin-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class RequiredPinModalComponent {
	loading = false;
	@Output() pinConfirmed = new EventEmitter();
	@ViewSelectSnapshot(BusinessUsersState.getLoggedInBusinessUser)
	currentUser: BusinessUser;

	constructor(
		private formBuilder: FormBuilder,
		private googleEncryptionService: GoogleEncryptionService,
		private snackbarService: SnackbarService,
	) {}

	form = this.formBuilder.group({
		pin: this.formBuilder.control('', [Validators.required]),
	});

	async validatePin() {
		this.loading = true;
		const pin = this.form.get('pin').value;
		if (!this.currentUser?.accessPin) {
			this.pinConfirmed.emit(false);
			this.loading = false;
			return this.snackbarService.openSnackBar({
				text: 'You do not have a PIN set. Please contact your administrator.',
				type: 'error',
			});
		}
		try {
			this.googleEncryptionService
				.decrypt(this.currentUser.accessPin)
				.pipe(untilDestroyed(this))
				.subscribe((decrypted) => {
					if (decrypted === pin) {
						this.pinConfirmed.emit(true);
						this.loading = false;
						return this.snackbarService.openSnackBar({
							text: 'Pin Confirmed',
							type: 'success',
						});
					}
					this.loading = false;
					this.pinConfirmed.emit(false);
					this.snackbarService.openSnackBar({
						text: 'Pin entered is incorrect',
						type: 'error',
					});
				});
		} catch {
			this.loading = false;
			this.pinConfirmed.emit(false);
			this.snackbarService.openSnackBar({
				text: 'You do not have a PIN set. Please contact your administrator.',
				type: 'error',
			});
		}
	}
}
